import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_notice_dismissed')) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem('cookie_notice_dismissed', '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] bg-[#0A2533] border-t border-white/10 py-3 px-6" data-testid="cookie-notice">
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-4">
        <p className="text-white/80 text-xs" style={{ fontFamily: "'Calibri', sans-serif" }}>
          This site uses only strictly necessary cookies to keep you signed in and to operate the platform.{' '}
          Read our <Link to="/privacy" className="text-[#4DD0E1] hover:underline">Privacy Policy</Link>.
        </p>
        <button onClick={dismiss} data-testid="cookie-notice-dismiss"
          className="px-4 py-1.5 bg-[#00707C] hover:bg-[#005F6A] text-white text-xs font-medium rounded-lg transition-colors whitespace-nowrap">
          Got it
        </button>
      </div>
    </div>
  );
}
